import { action, makeObservable, observable } from 'mobx';

class NotificationStore {
  notification = '';

  notificationDuration = 1000;

  constructor() {
    makeObservable(this, {
      notification: observable,
      notificationDuration: observable,
      setNotification: action.bound,
      removeNotification: action.bound,
    });
  }

  removeNotification() {
    this.notification = '';
  }

  setNotification = (data) => {
    this.notification = data;
    setTimeout(() => {
      this.removeNotification();
    }, this.notificationDuration);
  };
}

export const notificationStore = new NotificationStore();
